module.exports = __webpack_public_path__ + "img/cyber_blue_210.385a77d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/cyber-monday/cyber_blue_210.png
// module id = IaFJ
// module chunks = 1